import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const pomproductblockApi = api
  .enhanceEndpoints({ addTagTypes: ['POMProductBlock'] })
  .injectEndpoints({
    endpoints: builder => ({
      getPOMProductBlocks: builder.query<po_mkitchen[], string>({
        query: cid => `pomproductblock/${cid}`,
        providesTags: ['POMProductBlock']
      }),
      getPOMProductBlockById: builder.query<po_mkitchen, string>({
        query: id => `pomproductblock/byid/${id}`,
        providesTags: ['POMProductBlock']
      }),
      insertPOMProductBlock: builder.mutation({
        query: pomproductblock => ({
          url: `pomproductblock/`,
          method: 'POST',
          body: pomproductblock
        }),
        invalidatesTags: ['POMProductBlock']
      }),
      updatePOMProductBlock: builder.mutation({
        query: pomproductblock => ({
          url: `pomproductblock/`,
          method: 'PUT',
          body: pomproductblock
        }),
        invalidatesTags: ['POMProductBlock']
      }),
      deletePOMProductBlock: builder.mutation({
        query: pomproductblock => ({
          url: `pomproductblock/${pomproductblock.kt_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['POMProductBlock']
      })
    }),
    overrideExisting: false
  });

export const {
  useGetPOMProductBlocksQuery,
  useGetPOMProductBlockByIdQuery,
  useInsertPOMProductBlockMutation,
  useUpdatePOMProductBlockMutation,
  useDeletePOMProductBlockMutation
} = pomproductblockApi;

